import client from "../Client/HttpClient";
import { IPiarAdjustmentsModel } from "@/interfaces/modules";

const ApiPath = "PiarAdjustments";

export default {
  /** GET api/PiarAdjustments */
  GetAll: (): Promise<IPiarAdjustmentsModel[]> =>
    client.get(`${ApiPath}`),

  /** GET api/PiarAdjustments/{id} */
  GetById: (id: number): Promise<IPiarAdjustmentsModel> =>
    client.get(`${ApiPath}/${id}`),

  /** GET api/PiarAdjustments/byPiar/{piarId} */
  GetByPiarId: (piarId: number): Promise<IPiarAdjustmentsModel[]> =>
    client.get(`${ApiPath}/byPiar/${piarId}`),

  /** GET api/PiarAdjustments/bySubject/{subjectId} */
  GetBySubjectId: (subjectId: number): Promise<IPiarAdjustmentsModel[]> =>
    client.get(`${ApiPath}/bySubject/${subjectId}`),

  /** POST api/PiarAdjustments */
  Post: (data: IPiarAdjustmentsModel): Promise<IPiarAdjustmentsModel> =>
    client.post(`${ApiPath}`, data),
};
